import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {Router, BrowserRouter} from 'react-router-dom';

import register, {unregister as unregisterServiceWorker} from './registerServiceWorker';
import configureStore, {history} from './store/configureStore.js';
import AppRoutes from './routes/routes';
import 'core-js/stable';

const store = configureStore();
register();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <Router history={history}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Router>
  </Provider>
);

unregisterServiceWorker();
